module.exports = __webpack_public_path__ + "static/img/20161127-_MG_2745_1920x1440.3935e10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider/20161127-_MG_2745_1920x1440.jpg
// module id = hvFD
// module chunks = 1